import { useRef, useState } from "react";
import { Camera, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, imgUrl } from "@/lib/api";

export const PhotoPicker = ({ value, onChange, testId, size = "w-14 h-14", label }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    const form = new FormData();
    form.append("file", file);
    setBusy(true);
    try {
      const { data } = await api.post("/admin/upload", form);
      onChange(data.url);
      toast.success("Photo uploaded");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      data-testid={testId}
      onClick={() => ref.current?.click()}
      aria-label={label || "Upload photo"}
      className={`relative ${size} shrink-0 rounded-xl overflow-hidden bg-[#F0EBE1] border border-dashed border-[#D6CCBA] group`}
    >
      {value && <img src={imgUrl(value)} alt="" className="w-full h-full object-cover" />}
      <span className={`absolute inset-0 grid place-items-center text-white transition-opacity ${value && !busy ? "bg-black/40 opacity-0 group-hover:opacity-100" : "bg-black/30"}`}>
        {busy ? <Loader2 size={18} className="animate-spin" /> : <Camera size={18} />}
      </span>
      <input ref={ref} type="file" accept="image/*" onChange={pick} className="hidden" data-testid={`${testId}-input`} />
    </button>
  );
};
